import Vue from "vue";
import firebase from "firebase/app";
import 'firebase/messaging'

import config from '../../../load-config';

config.then((configValues) => {
    var firebaseConfig = {
        apiKey: `${configValues.VUE_APP_FIREBASE_API_KEY}`,
        authDomain: `${configValues.VUE_APP_FIREBASE_AUTH_DOMAIN}`,
        databaseURL: `${configValues.VUE_APP_FIREBASE_DATABASE_URL}`,
        projectId: `${configValues.VUE_APP_FIREBASE_PROJECT_ID}`,
        storageBucket: `${configValues.VUE_APP_FIREBASE_STORAGE_BUCKET}`,
        messagingSenderId: `${configValues.VUE_APP_FIREBASE_MESSAGING_SENDER_ID}`,
        appId: `${configValues.VUE_APP_FIREBASE_APP_ID}`,
        measurementId: `${configValues.VUE_APP_FIREBASE_MEASUREMENT_ID}`,
    };
    if (firebase.messaging.isSupported()) {
        firebase.initializeApp(firebaseConfig)

        var messaging = firebase.messaging();

        Vue.prototype.$messaging = messaging

        navigator.serviceWorker.register('/firebase-messaging-sw.js')
            .then((registration) => {
                Vue.prototype.$messaging.useServiceWorker(registration)
            }).catch(e => {
                console.log(e)
            })
    }
});